import React, { useContext, useEffect, useState } from 'react';
import { MenuNavStyled } from './styles';
import { ContentContext } from '../../../context';
import { useParams, useNavigate } from 'react-router-dom';

const MenuNav = (props) => {

    const { slug } = useParams();
    const navigate = useNavigate();

    const { setShowNav } = props;

    const { goto, 
            setGoto,
            productLoaded,
            isLoged,
            experienceLoaded,
            setExperienceLoaded } = useContext(ContentContext);

    const [ productName, setProductName ] = useState("");
    

    useEffect(() => {
       
        if(productLoaded){
            
            let header = "";
            switch (productLoaded) {
                case "gallinas":
                    setProductName("Gallinas Felices");
                    break;
                case "frutas_y_vegetales":
                    setProductName("Frutas y Vegetales");
                    break;
                case "santo_padre":
                    setProductName("Santo Padre");
                    break;
                case "panaderia_del_pueblo":
                    setProductName("Panaderia de Pueblo");
                    break;
                case "resena":
                    setProductName("Reseña");
                    break;
                case "siete_cabritos":
                    setProductName("Siete Cabritos");
                    break;
                default:
                    break;
            }
            setGoto(productLoaded);

        }
    
      return () => {}
    }, [productLoaded])

    const handleGoto = (goto) => {
        console.log("goto", goto);
        setShowNav(false);
        navigate(goto);
    }

    useEffect(() => {
      console.log("productLoaded", productLoaded)
    
      return () => {}
    }, [])
    
    

    return (
        <MenuNavStyled>
            <ul>
                <li className='slideInDown delay1' onClick={() => handleGoto("conocenos")}>
                    <p>Conocenos</p>
                </li>
                <li className='slideInDown delay4' onClick={() => handleGoto("eventos")}>
                    <p>Eventos</p>
                </li>
                {/* <li className='slideInDown delay1' onClick={() => handleGoto("bienvenidos")}>
                    <p>Bienvenidos</p>
                </li> */}
                {/* {experienceLoaded !== null ?
                <li className='slideInDown delay2' onClick={() => handleGoto(`${goto}`)}>
                    <p>{productName}</p>
                </li> : ""} */}

                {/*isLoged ?
                <li className='slideInDown delay3' onClick={() => handleGoto("mi_avance")}>
                    <p>Mi Avance</p>
                </li> : ""*/}

                {/* <li className='slideInDown delay4' onClick={() => handleGoto("quienes_somos")}>
                    <p>Quienes Somos</p>
                </li> */}
                {/* <li className='slideInDown delay5' onClick={() => handleGoto("bases_y_condiciones")}>
                    <p>Bases y Condiciones</p>
                </li> */}
            </ul>
        </MenuNavStyled>
    );
};

export default MenuNav;